<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="目录名称">
        <el-input
          v-model="queryForm.catalogName"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-left: 80px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getCmsArticleCatalogList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetDialog"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addCmsArticleCatalog"
          >新建</el-button>
          <el-button
            type="warning"
            plain
            size="small"
            icon="el-icon-edit"
            :disabled="multipleSelection.length != 1"
            @click="editCmsArticleCatalog(null)"
          >修改</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteCmsArticleCatalog(null)"
          >删除</el-button>
        </div>

        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshCmsArticleCatalogList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        :data="cmsArticleCatalogList"
        size="small"
        row-key="id"
        height="100%"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="10%"
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          prop="catalogName"
          label="目录名称"
          width='150'
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="catalogPic"
          label="图片"
          width='100'
        >
          <template slot-scope="scope">
              <div v-if='scope.row.catalogPic'>
                  <el-image
                      @click='updateSrcList(scope.row.catalogPic)'
                      style="width: 30px; height: 30px"
                      :src="scope.row.catalogPic"
                      :preview-src-list="srcList"
                  > </el-image>
              </div>
              <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="catalogDesc"
          label="目录描述"
          width='100'
        > </el-table-column>
        <el-table-column
          align="center"
          label="排序"
          width='180'
        >
          <template slot-scope="scop">
            <el-input-number
              style="width:150px"
              v-model="scop.row.sort"
              @change="changeSort(scop.row)"
              size="small"
              label=""
              :min="1"
              :max="1000"
              :step="10"
              :controls="true"
              controls-position="both"
            >
            </el-input-number>
          </template>
        </el-table-column>
          <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              prop="id"
              label="目录ID"
              width='300'
          > </el-table-column>

        <el-table-column
          fixed="right"
          align="center"
          label="操作"
          width='300'
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkCmsArticleCatalog(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editCmsArticleCatalog(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div
                @click="deleteCmsArticleCatalog(scop.row.id)"
                style="color: red"
              >
                <Icon size="16">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label">删除</span>
              </div>
              <div @click="addCatalog(scop.row.id)">
                <Icon size="16">
                  <AddCircle24Regular />
                </Icon>
                <span class="operation-label">添加下级目录</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog
        :title="cmsArticleCatalogStates[cmsArticleCatalogState]"
        :visible.sync="showDialog"
        width="400px"
        @close="closeDialog"
        :append-to-body="true"
      >
        <div>
          <el-form
            :model="cmsArticleCatalog"
            ref="cmsArticleCatalogForm"
            :rules="rules"
            label-width="80px"
            :inline="true"
            size="mini"
          >
            <el-form-item
              label="目录名称"
              prop="catalogName"
            >
              <el-input
                style="width:200px"
                size="small"
                v-model="cmsArticleCatalog.catalogName"
                :disabled="cmsArticleCatalogState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="上级目录"
              prop="parentId"
            >
              <el-select
                style="width:200px"
                v-model="cmsArticleCatalog.parentId"
                placeholder="请选择"
                :disabled="cmsArticleCatalogState == 'check'"
                clearable
                size="small"
              >
                <el-tree
                  default-expand-all
                  :data="cmsArticleCatalogList"
                  :props="treeProps"
                >
                  <div
                    class="custom-tree-node flex items-center"
                    slot-scope="{ node, data }"
                  >
                    <el-option
                      :label="node.label"
                      :value="data.id"
                    > </el-option>
                  </div>
                </el-tree>
              </el-select>
            </el-form-item>

            <el-form-item label="图片">
              <el-upload
                action=""
                :disabled="cmsArticleCatalogState == 'check'"
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadImage"
              >
                <img
                  v-if="cmsArticleCatalog.catalogPic"
                  :src="cmsArticleCatalog.catalogPic"
                  class="avatar"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="目录描述"
              prop="catalogDesc"
            >
              <el-input
                style="width:200px"
                size="small"
                v-model="cmsArticleCatalog.catalogDesc"
                :disabled="cmsArticleCatalogState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              align="center"
              label="排序"
            >

              <el-input-number
                style="width:200px"
                v-model="cmsArticleCatalog.sort"
                :disabled="cmsArticleCatalogState == 'check'"
                size="small"
                label=""
                :min="1"
                :max="10000"
                :step="10"
                :controls="true"
                @change="editChangeSort"
                controls-position="both"
              >
              </el-input-number>

            </el-form-item>

          </el-form>
        </div>

        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="cmsArticleCatalogState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    AddCircle24Regular
} from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        AddCircle24Regular
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetCmsArticleCatalogList();
                this.getCmsArticleCatalogList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetCmsArticleCatalogList();
                this.getCmsArticleCatalogList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                catalogName: '' //名称
            },
            srcList:[''], //大预览图
            loading: false,
            showDialog: false,
            isImportDate: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            cmsArticleCatalogState: 'add',
            cmsArticleCatalogStates: {
                add: '新建文章目录',
                check: '查看文章目录',
                edit: '修改文章目录'
            },

            multipleSelection: [],
            cmsArticleCatalogList: [],
            isSearch: false,
            cmsArticleCatalog: {
                id: '', //ID
                catalogName: '', //名称
                catalogPic: '', //图片
                sort: '1', //排序
                parentId: '', //上级
                deleteFlag: 0
            },
            btnLoading: false,

            rules: {
                id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                catalogName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                catalogPic: [{ required: true, message: '图片不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
            },
            treeProps: {
                children: 'children',
                label: 'catalogName'
            }
        };
    },
    created() {

    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        init(){
            this.refreshCmsArticleCatalogList()
        },
        resetCmsArticleCatalogList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.cmsArticleCatalogList = [];
        },
        resetDialog() {
            this.cmsArticleCatalogState = 'add';
            this.showDialog = false;
            this.queryForm = {
                catalogName: '' //名称
            };
            this.getCmsArticleCatalogList();
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.cmsArticleCatalogState == 'add') {
                this.$refs.cmsArticleCatalogForm.validate((valid) => {
                    if (valid) {
                        post(`/cms/catalog/add`, { ...this.cmsArticleCatalog }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetCmsArticleCatalogList();
                                this.resetDialog();
                                this.getCmsArticleCatalogList();
                            }
                        });
                    }
                });
            } else if (this.cmsArticleCatalogState == 'edit') {
                this.$refs.cmsArticleCatalogForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.cmsArticleCatalog.children;
                        post(`/cms/catalog/edit`, { ...this.cmsArticleCatalog }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetCmsArticleCatalogList();
                                this.resetDialog();
                                this.getCmsArticleCatalogList();
                            }
                        });
                    }
                });
            }
        },
        addCmsArticleCatalog() {
            this.cmsArticleCatalog = {
                id: '', //ID
                catalogName: '', //名称
                catalogPic: '', //图片
                sort: '', //排序
                parentId: '' //上级
            };
            this.showDialog = true;
            this.cmsArticleCatalogState = 'add';
        },
        checkCmsArticleCatalog(cmsArticleCatalogId) {
            this.currentCmsArticleCatalogId = cmsArticleCatalogId;
            this.getCmsArticleCatalogById();
            this.showDialog = true;
            this.cmsArticleCatalogState = 'check';
        },
        editCmsArticleCatalog(cmsArticleCatalogId) {
            console.log('cmsArticleCatalog', cmsArticleCatalogId);
            if (cmsArticleCatalogId) {
                this.currentCmsArticleCatalogId = cmsArticleCatalogId;
                this.getCmsArticleCatalogById();
            } else {
                this.cmsArticleCatalog = { ...this.cmsArticleCatalog, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.cmsArticleCatalogState = 'edit';
        },
        deleteCmsArticleCatalog(cmsArticleCatalogId) {
            let ids = '';
            if (cmsArticleCatalogId) {
                ids = cmsArticleCatalogId;
            } else {
                ids = this.multipleSelection.map((cmsArticleCatalog) => cmsArticleCatalog.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/cms/catalog/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetCmsArticleCatalogList();
                            this.getCmsArticleCatalogList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshCmsArticleCatalogList() {
            this.resetCmsArticleCatalogList();
            this.getCmsArticleCatalogList();
        },
        getCmsArticleCatalogList() {
            this.loading = true;
            get(`/cms/catalog/findAllAsTree`, { ...this.queryForm }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.cmsArticleCatalogList = res.catalog;
                    this.totalNum = res.catalog.length
                }
            });
        },
        getCmsArticleCatalogById() {
            get(`/cms/catalog/get`, { id: this.currentCmsArticleCatalogId }).then((res) => {
                if (res.success) {
                    if (res.cmsArticleCatalog.parentId === '0') {
                        res.cmsArticleCatalog.parentId = '';
                    }
                    this.cmsArticleCatalog = { ...this.cmsArticleCatalog, ...res.cmsArticleCatalog };
                }
            });
        },
        /**
         * 导出出岗位信息
         */
        exportCmsArticleCatalogList() {
            this.btnLoading = true;
            exprotExcel(`/cms/catalog/export`, this.cmsArticleCatalog, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/cms/catalog/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload('/mpp/image/upload', formData).then((res) => {
                console.log(res);
                if (res.success) {
                    this.cmsArticleCatalog.catalogPic = res.url;
                }
                console.log(this.cmsArticleCatalog.catalogPic);
            });
        },
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getCmsArticleCatalogList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getCmsArticleCatalogList();
        },
        changeSort(catalog) {
            console.log(catalog);
            if (!catalog.parentId) {
                delete catalog.parentId;
            }
            delete catalog.children;
            post(`/cms/catalog/edit`, { ...catalog }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑成功`,
                        type: 'success',
                        duration: 2000
                    });
                    this.refreshCmsArticleCatalogList();
                }
            });
        },
        addCatalog(id) {
            // (this.cmsArticleCatalog = {}),
            this.cmsArticleCatalog = {
                id: '', //ID
                catalogName: '', //名称
                catalogPic: '', //图片
                sort: '', //排序
                parentId: '' //上级
            };
            this.cmsArticleCatalog.parentId = id;
            this.showDialog = true;
            this.menuState = 'add';
        },
        editChangeSort(e) {
            console.log(e);
            this.cmsArticleCatalog.sort = e;
        },

        updateSrcList(src){
            this.srcList[0] = src
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>
